module.exports = __webpack_public_path__ + "static/media/tapir-orange.35d2483b.png";